"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdQuery = exports.orderDir = exports.orderBy = exports.page = exports.PositiveIntFromString = void 0;
const effect_1 = require("effect");
// Query structs stay anonymous. Identifiers are optional now that
// expandIdentifiedParameterSchemas is available; these specs leave them off.
exports.PositiveIntFromString = effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.positive());
// The runtime always falls back to page 1 (execPagSortedQuery).
exports.page = effect_1.Schema.optionalWith(exports.PositiveIntFromString, { exact: true, default: () => 1 });
exports.orderBy = effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true });
exports.orderDir = effect_1.Schema.optionalWith(effect_1.Schema.Literal('asc', 'desc'), { exact: true });
exports.IdQuery = effect_1.Schema.Struct({ id: effect_1.Schema.NonEmptyString });
//# sourceMappingURL=shared.js.map